import { API_BASE_URL } from "./apiBaseUrl";

export interface BerryBoxTier {
  min: number;
  max: number | null;
  priceRub: number;
}

export interface ShopDeliveryConfig {
  berryBoxTiers: BerryBoxTier[];
  cityDeliveryRub: number;
  freeDeliveryFromRub: number;
  troutFirstBoxRub: number;
  troutExtraBoxRub: number;
  troutLiftPerBoxRub: number;
}

export const DEFAULT_SHOP_DELIVERY_CONFIG: ShopDeliveryConfig = {
  berryBoxTiers: [
    { min: 1, max: 3, priceRub: 400 },
    { min: 4, max: 8, priceRub: 500 },
    { min: 9, max: 13, priceRub: 600 },
    { min: 14, max: 19, priceRub: 700 },
    { min: 20, max: null, priceRub: 800 },
  ],
  cityDeliveryRub: 400,
  freeDeliveryFromRub: 5000,
  troutFirstBoxRub: 600,
  troutExtraBoxRub: 200,
  troutLiftPerBoxRub: 200,
};

function isBerryTier(x: unknown): x is BerryBoxTier {
  if (!x || typeof x !== "object") return false;
  const o = x as Record<string, unknown>;
  return (
    typeof o.min === "number" &&
    (typeof o.max === "number" || o.max === null) &&
    typeof o.priceRub === "number"
  );
}

function parsePayload(raw: unknown): ShopDeliveryConfig | null {
  if (!raw || typeof raw !== "object") return null;
  const o = raw as Record<string, unknown>;
  const tiers = o.berryBoxTiers;
  if (!Array.isArray(tiers) || !tiers.every(isBerryTier)) return null;
  const cityDeliveryRub = o.cityDeliveryRub;
  const freeDeliveryFromRub = o.freeDeliveryFromRub;
  const troutFirstBoxRub = o.troutFirstBoxRub;
  const troutExtraBoxRub = o.troutExtraBoxRub;
  const troutLiftPerBoxRub = o.troutLiftPerBoxRub;
  if (
    typeof cityDeliveryRub !== "number" ||
    typeof freeDeliveryFromRub !== "number" ||
    typeof troutFirstBoxRub !== "number" ||
    typeof troutExtraBoxRub !== "number" ||
    typeof troutLiftPerBoxRub !== "number"
  ) {
    return null;
  }
  return {
    berryBoxTiers: tiers,
    cityDeliveryRub,
    freeDeliveryFromRub,
    troutFirstBoxRub,
    troutExtraBoxRub,
    troutLiftPerBoxRub,
  };
}

export async function fetchShopDeliveryConfig(): Promise<ShopDeliveryConfig> {
  const base = API_BASE_URL.replace(/\/+$/, "");
  const url = `${base}/GetShopConfig.php`;
  try {
    const res = await fetch(url, { method: "GET", credentials: "include" });
    if (!res.ok) return DEFAULT_SHOP_DELIVERY_CONFIG;
    const json: unknown = await res.json();
    const parsed = parsePayload(json);
    return parsed ?? DEFAULT_SHOP_DELIVERY_CONFIG;
  } catch {
    return DEFAULT_SHOP_DELIVERY_CONFIG;
  }
}
